import React from "react";
import { NavLink } from "react-router-dom";
import "jquery/dist/jquery.min.js";
import $ from "jquery";

const showSpinner = () => {
  $("#cover-spin").show(0);
};
const LoginError = () => {
  window.onunload = function () {
    var win = window.opener;
    if (!win.closed) {
      alert("asdsad")
      // win.someFunctionToCallWhenPopUpCloses();
    }
  };
  return (
    <div id="login-error" className="d-none">
      <div className="detail-title"></div>

      <div className="row clearfix">
        <div className="col-lg-12 text-center">
          <div className="box-detail">
            <div className="box-title-1">Sta de pop-up toe en vernieuw de pagina.</div>
          </div>
          <br />
         
        </div>
      </div>
    </div>
  );
};

export default LoginError;
